import * as React from "react";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axiosConfig from "./utils/axiosConfig";
import HeaderSubPage from "./partial/HeaderSubPage";
import {notify} from "./utils/utils";
import {ToastContainer} from "react-toastify";

export default function NewsletterUnsubscribe({partner}) {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [status, setStatus] = useState(null);

    const doUnsubscribe = async () => {
        try {
            const response = await axiosConfig.get(`/newsletter/unsubscription?token=${token}`);
            setStatus(response.status);
            notify(response?.data?.message, "success");
        } catch (error) {
            notify(error?.response?.data?.message || "Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.");
            setStatus(error?.response?.status);
        }
    };

    useEffect(() => {
        if (token) {
            doUnsubscribe();
        }
    }, [token]);

    useEffect(() => {
        document.title = `${partner?.name} - Newsletter Abmeldung`;
    }, [partner]);

    return (
        <div>
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPage title={'Newsletter Abmeldung'}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="site-main col-sm-12">
                                <h1>
                                    Newsletter Abmeldung
                                </h1>
                                {status === 200 ? (
                                    <p>
                                        Wir bedauern sehr, dass Sie sich von unserem Newsletter abgemeldet haben.
                                        Wunschgemäß haben wir Sie natürlich aus der Empfängerliste ausgetragen.
                                    </p>
                                ) : status ? (
                                    <p>
                                        Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.
                                    </p>
                                ) : (
                                    <p>Wird geladen...</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}